import { render, staticRenderFns } from "./StaticPagesManagement.vue?vue&type=template&id=eb1757f2&"
import script from "./StaticPagesManagement.vue?vue&type=script&lang=js&"
export * from "./StaticPagesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports